import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormFieldGroupExpandable, FormFieldGroupHeader } from '@patternfly/react-core';
import { useContext } from 'react';
import { useFieldValue } from '../../hooks/field-value';
import { CanvasFormTabsContext } from '../../providers/canvas-form-tabs.provider';
import { SchemaProvider } from '../../providers/SchemaProvider';
import { isDefined } from '../../utils';
import { capitalizeString } from '../../utils/capitalize-string';
import { ObjectFieldInner } from './ObjectFieldInner';
export const GroupFields = ({ propName, groups, requiredProperties }) => {
    const { selectedTab } = useContext(CanvasFormTabsContext);
    const { value } = useFieldValue(propName);
    return (_jsx(_Fragment, { children: groups.map(([groupName, groupProperties]) => {
            if (selectedTab === 'Required') {
                const hasRequiredProperty = Object.keys(groupProperties).some((propName) => requiredProperties.includes(propName));
                const hasObjectTypeProperty = Object.keys(groupProperties).some((propName) => {
                    if (groupProperties[propName].type === 'object' ||
                        groupProperties[propName].type === 'array' ||
                        '$ref' in groupProperties[propName]) {
                        return isDefined(value) && isDefined(value[propName]);
                    }
                });
                if (!hasRequiredProperty && !hasObjectTypeProperty) {
                    return null;
                }
            }
            else if (selectedTab === 'Modified') {
                const hasModifiedProperty = Object.keys(groupProperties).some((propName) => isDefined(value) && isDefined(value[propName]));
                if (!hasModifiedProperty) {
                    return null;
                }
            }
            const name = capitalizeString(groupName);
            return (_jsx(FormFieldGroupExpandable, { className: "kaoto-form__expandable-group", toggleAriaLabel: `Toggle ${name} group`, header: _jsx(FormFieldGroupHeader, { titleText: { text: name, id: `${propName}-${name}` } }), children: _jsx(SchemaProvider, { schema: { properties: groupProperties }, children: _jsx(ObjectFieldInner, { propName: propName, requiredProperties: requiredProperties }) }) }, `${name}-section-toggle`));
        }) }));
};
//# sourceMappingURL=GroupFields.js.map